import React from 'react';
import { Button } from 'antd';
import { DiscordOutlined } from '@ant-design/icons';

const LoginButton = () => {
  const discordAuthUrl = 'https://discord.com/oauth2/authorize?client_id=1277715455250923580&response_type=code&redirect_uri=https%3A%2F%2Ffuchsbot.ocame.de%2Fauth%2Fcallback&scope=identify';

  return (
    <Button
      type="primary"
      icon={<DiscordOutlined />}
      onClick={() => window.location.href = discordAuthUrl}
    >
      Mit Discord anmelden
    </Button>
  );
};

export default LoginButton;
